import { Component, OnDestroy, Input } from '@angular/core';
import { CameraService } from '../../services/camera.service';

@Component({
  selector: 'avs-rtsp-player',
  standalone: false,
  templateUrl: './rtsp-player.component.html',
  styleUrl: './rtsp-player.component.css'
})
export class RtspPlayerComponent implements OnDestroy {
  private ws?: WebSocket;
  private mediaSource = new MediaSource();
  private sourceBuffer?: SourceBuffer;
  @Input() rs: string = ''; // Stream-GUID
  @Input() token: string = ''; // JWT-Token

  constructor(private cameraService: CameraService) { }

  ngAfterViewInit() {
    const video = document.querySelector('video') as HTMLVideoElement;
    video.src = URL.createObjectURL(this.mediaSource);

    this.mediaSource.addEventListener('sourceopen', () => {
      // Beispiel: Annahme H264/mp4 als MIME Type (Backend entsprechend konfigurieren)
      this.sourceBuffer = this.mediaSource.addSourceBuffer('video/mp4; codecs="avc1.42E01E"');

      // WebSocket starten, sobald SourceBuffer bereit ist
      this.startWebSocketStream();
    });
  }

  startWebSocketStream() {
    /*     const rs = 'dein-stream-guid';
        const token = 'dein-jwt-token'; */
    this.ws = this.cameraService.getRtspWebSocketStream(this.rs, this.token);

    this.ws.onopen = () => console.log('WebSocket verbunden');
    this.ws.onmessage = async (event) => {
      if (!(event.data instanceof ArrayBuffer)) return;
      const data = new Uint8Array(event.data);

      if (this.sourceBuffer && !this.sourceBuffer.updating) {
        try {
          this.sourceBuffer.appendBuffer(data);
        } catch (e) {
          console.error('Fehler beim Anhängen des Buffers:', e);
        }
      }
    };

    this.ws.onclose = () => console.log('WebSocket geschlossen');
    this.ws.onerror = (error) => console.error('WebSocket Fehler:', error);
  }

  ngOnDestroy() {
    if (this.ws) {
      this.ws.close();
    }
  }
}
